import { render, staticRenderFns } from "./HistorialTransferencias.vue?vue&type=template&id=8d650bc4&scoped=true&"
import script from "./HistorialTransferencias.vue?vue&type=script&lang=js&"
export * from "./HistorialTransferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d650bc4",
  null
  
)

export default component.exports